import { memo } from "react";
import { Handle, Position } from "@xyflow/react";

interface InvoiceNodeProps {
  data: {
    label: string;
  };
}

const RawInvoiceNode = ({ data }: InvoiceNodeProps) => {
  return (
    <div
      style={{
        backgroundColor: "#dedee3",
        padding: 8,
        border: "1px solid #999",
        borderRadius: 4,
        fontSize: 14,
        minWidth: 160,
        textAlign: "center",
        position: "relative",
      }}
    >
      {data.label}

      {/* ➡️ Out to batch */}
      <Handle
        type="source"
        position={Position.Right}
        id="to-batch"
        style={{ background: "#333" }}
      />

      {/* ⬇️ Out to inventory */}
      <Handle
        type="source"
        position={Position.Bottom}
        id="to-inventory"
        style={{ background: "#888" }}
      />

      {/* ⬅️ Optional incoming */}
      <Handle
        type="target"
        position={Position.Left}
        style={{ background: "#555" }}
      />
    </div>
  );
};

// ✅ Fix ESLint warning and ensure DevTools name
const InvoiceNode = memo(RawInvoiceNode);
InvoiceNode.displayName = "InvoiceNode";

export default InvoiceNode;
